import { render, staticRenderFns } from "./AssessmentModule.vue?vue&type=template&id=3db9b4d0&scoped=true&"
import script from "./AssessmentModule.vue?vue&type=script&lang=js&"
export * from "./AssessmentModule.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentModule.vue?vue&type=style&index=0&id=3db9b4d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db9b4d0",
  null
  
)

export default component.exports